export const BREAKPOINT_TABLET = 767;
export const BREAKPOINT_DESKTOP_1023 = 1023;
